<template lang="pug">
    v-sheet.mb-2(
        v-bind:style="{ height: sheetHeight + 'px' }"
        color="white"
        elevation="2"
        rounded
        style="padding: 0 !important;"
    )

        v-simple-table(style="width: 100%;" v-if="validDayDashboardSummary && !teamScopeEmptyMessage")
            template(v-slot:default)
                tbody
                    tr
                        td.no-wrap.lg-width.xs-height.task-border-right
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Calls Waiting
                                    .text-h4.font-weight-bold(v-bind:style="{ color: callsWaitingColor }") {{ totalCallsWaiting | number }}
                                v-spacer
                                .ml-auto
                                    v-icon(size="45" v-bind:class="[callsWaitingClass]")
                                        | mdi-phone-clock

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Current Hold Time
                                    template(v-if="longestHoldSeconds > 0")
                                        .text-h4.font-weight-bold(v-bind:style="{ color: currentHoldTimeColor }") {{ (longestHoldSeconds || 0) | secondsToFullWords }}
                                    template(v-else)
                                        .text-h4.font-weight-bold ---
                                v-spacer
                                .ml-auto
                                    v-icon(size="45" v-bind:class="[currentHoldTimeClass]")
                                        | mdi-timer-sand

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Waiting > 90 seconds
                                    .text-h4.font-weight-bold(v-bind:style="{ color: longHoldCallColor }") {{ totalLongHoldCalls | number }}
                                v-spacer
                                .ml-auto
                                    v-icon(size="45" v-bind:class="[longHoldCallClass]")
                                        | mdi-alert-circle

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Service Level %
                                    template(v-if="currentDayDashboardSummary.phone_inbound_call_count > 0")
                                        .text-h4.font-weight-bold(v-bind:style="{ color: serviceLevelColor }") {{ (serviceLevel || 0).toFixed(2) | number }}%
                                    .text-h4.font-weight-bold(v-else) ---
                                v-spacer
                                .ml-auto
                                    v-progress-circular(
                                        rotate="90"
                                        :size="45"
                                        :width="10"
                                        :value="serviceLevel"
                                        :color="serviceLevelColor"
                                    )

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Agent Drop %
                                    .text-h4.font-weight-bold(v-bind:style="{ color: agentDropColor }") {{ (agentDropPercentage || 0).toFixed(2) | number }}%
                                v-spacer
                                .ml-auto
                                    v-icon(size="45" v-bind:class="[agentDropClass]")
                                        | mdi-account-cancel

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Adj Agent Drop %
                                    .text-h4.font-weight-bold(v-bind:style="{ color: adjustedAgentDropColor }") {{ (adjustedAgentDropPercentage || 0).toFixed(2) | number }}%
                                v-spacer
                                .ml-auto
                                    v-icon(size="45" v-bind:class="[adjustedAgentDropClass]")
                                        | mdi-account-cancel

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Avg Hold Time
                                    .text-h4.font-weight-bold {{ (averageHoldTime || 0) | secondsToFullWords }}
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-account-clock

                        //- td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                        //-     .d-flex.align-center
                        //-         .ml-2.mr-1.text-left
                        //-             .text-subtitle-1.font-weight-medium.volie-color-blue Avg Speed of Answer
                        //-             .text-h4.font-weight-bold
                        //-         v-spacer
                        //-         .ml-auto
                        //-             v-icon.volie-color-blue(size="45")
                        //-                 | mdi-alert-circle

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Avg IB Talk Time
                                    .text-h4.font-weight-bold {{ (averageInboundTalkTime || 0) | secondsToFullWords }}
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-headset

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Avg IB Wrap Up
                                    .text-h4.font-weight-bold {{ (averageInboundWrapUp || 0) | secondsToFullWords }}
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-clipboard-check

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Avg OB Talk Time
                                    .text-h4.font-weight-bold {{ (averageOutboundTalkTime || 0) | secondsToFullWords }}
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-headset

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Avg OB Wrap Up
                                    .text-h4.font-weight-bold {{ (averageOutboundWrapUp || 0) | secondsToFullWords }}
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-clipboard-check

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Avg OB Contact %
                                    .text-h4.font-weight-bold {{ (outboundContactPercentage || 0).toFixed(2) | number }}%
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-phone-check

        .d-flex.align-center.justify-center.px-4(v-else-if="teamScopeEmptyMessage" v-bind:style="{ height: sheetHeight + 'px' }")
            v-alert(type="info" dense outlined style="width: 100%;")
                | {{ teamScopeEmptyMessage }}

        .text-center(v-else)
            v-progress-circular(
                :size='50'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 25px;"
            )

</template>

<script lang="ts">
    import Vue from 'vue';

    import { adjustedAgentDropRate, agentDropRate } from '@/helpers/dashboard_summary';

    export default Vue.extend({
        data() {
            return {
                isLoading: false,
                longCallDuration: 90,
            }
        },
        methods: {
            calculatePercentage(x, y) {
                if (!x || !y) {
                    return 0;
                }
                return (x / y) * 100.0;
            },
        },
        computed: {
            adjustedAgentDropClass() {

                // alert error
                if (this.adjustedAgentDropPercentage >= 20) {
                    return "error--text";
                }

                // alert warning
                if (this.adjustedAgentDropPercentage >= 10) {
                    return "warning--text";
                }

                // alert success
                return "green--text";
            },
            adjustedAgentDropColor() {

                // alert error
                if (this.adjustedAgentDropPercentage >= 20) {
                    return "var(--error)";
                }

                // alert warning
                if (this.adjustedAgentDropPercentage >= 10) {
                    return "var(--orange)";
                }

                // alert success
                return "var(--success)";
            },
            agentDropClass() {

                // alert error
                if (this.agentDropPercentage >= 20) {
                    return "error--text";
                }

                // alert warning
                if (this.agentDropPercentage >= 10) {
                    return "warning--text";
                }

                // alert success
                return "green--text";
            },
            agentDropColor() {

                // alert error
                if (this.agentDropPercentage >= 20) {
                    return "var(--error)";
                }

                // alert warning
                if (this.agentDropPercentage >= 10) {
                    return "var(--orange)";
                }

                // alert success
                return "var(--success)";
            },
            agentDropPercentage() {
                return agentDropRate(this.currentDayDashboardSummary);
            },
            adjustedAgentDropPercentage() {
                return adjustedAgentDropRate(this.currentDayDashboardSummary);
            },
            adjustedVoiceMailPercentage() {
                return this.currentDayDashboardSummary?.phone_missed_call_voice_mail_count > 0 && this.currentDayDashboardSummary?.phone_inbound_call_count > 0 ? this.calculatePercentage(this.currentDayDashboardSummary.phone_missed_call_voice_mail_count - (this.currentDayDashboardSummary?.phone_missed_call_voice_mail_contact_count || 0), this.currentDayDashboardSummary.phone_inbound_call_count) : 0;
            },
            averageHoldTime() {
                return this.currentDayDashboardSummary?.total_inbound_hold_duration > 0 && this.currentDayDashboardSummary?.phone_inbound_call_count > 0 ? Math.floor(this.currentDayDashboardSummary.total_inbound_hold_duration / this.currentDayDashboardSummary.phone_inbound_call_count) : 0;
            },
            averageInboundTalkTime() {
                return this.currentDayDashboardSummary?.total_inbound_talk_duration > 0 && this.currentDayDashboardSummary?.phone_inbound_call_answered_count > 0 ? Math.floor(this.currentDayDashboardSummary.total_inbound_talk_duration / this.currentDayDashboardSummary.phone_inbound_call_answered_count) : 0;
            },
            averageInboundWrapUp() {
                return this.currentDayDashboardSummary?.total_inbound_wrap_up_duration > 0 && this.currentDayDashboardSummary?.phone_inbound_call_answered_count > 0 ? Math.floor(this.currentDayDashboardSummary.total_inbound_wrap_up_duration / this.currentDayDashboardSummary.phone_inbound_call_answered_count) : 0;
            },
            averageOutboundTalkTime() {
                return this.currentDayDashboardSummary?.total_outbound_talk_duration > 0 && this.currentDayDashboardSummary?.phone_inbound_call_count > 0 ? Math.floor(this.currentDayDashboardSummary.total_outbound_talk_duration / this.currentDayDashboardSummary.phone_inbound_call_count) : 0;
            },
            averageOutboundWrapUp() {
                return this.currentDayDashboardSummary?.total_outbound_wrap_up_duration > 0 && this.currentDayDashboardSummary?.phone_inbound_call_count > 0 ? Math.floor(this.currentDayDashboardSummary.total_outbound_wrap_up_duration / this.currentDayDashboardSummary.phone_inbound_call_count) : 0;
            },
            callsWaitingClass() {

                // alert error
                if (this.totalCallsWaiting >= 5) {
                    return "error--text";
                }

                // alert warning
                if (this.totalCallsWaiting > 0) {
                    return "warning--text";
                }

                // alert success
                return "volie-color-blue";
            },
            callsWaitingColor() {

                // alert error
                if (this.totalCallsWaiting >= 5) {
                    return "var(--error)";
                }

                // alert warning
                if (this.totalCallsWaiting > 0) {
                    return "var(--orange)";
                }

                // alert success
                return null;
            },
            currentHoldTimeClass() {

                // alert error
                if (this.longestHoldSeconds >= 90) {
                    return "error--text";
                }

                // alert warning
                if (this.longestHoldSeconds >= 30) {
                    return "warning--text";
                }

                // alert success
                if (this.longestHoldSeconds > 0) {
                    return "green--text";
                }

                return "volie-color-blue";
            },
            currentHoldTimeColor() {

                // alert error
                if (this.longestHoldSeconds >= 90) {
                    return "var(--error)";
                }

                // alert warning
                if (this.longestHoldSeconds >= 30) {
                    return "var(--orange)";
                }

                // alert success
                if (this.longestHoldSeconds > 0) {
                    return "var(--success)";
                }

                // Volie blue
                return "0f5b9a";
            },
            longestHoldSeconds() {
                return this.callsWaiting?.length > 0 ? this.callsWaiting[0].hold_time_in_seconds : -1;
            },
            longHoldCallClass() {

                // alert error
                if (this.totalLongHoldCalls > 0) {
                    return "error--text";
                }

                // alert green if calls waiting
                if (this.totalCallsWaiting > 0) {
                    return "green--text";
                }

                return "volie-color-blue";
            },
            longHoldCallColor() {

                // alert error
                if (this.totalLongHoldCalls > 0) {
                    return "var(--error)";
                }

                // alert green if calls waiting
                if (this.totalCallsWaiting > 0) {
                    return "var(--success)";
                }

                // alert success
                return null;
            },
            outboundContactPercentage() {
                return this.currentDayDashboardSummary?.phone_outbound_contact_count > 0 && this.currentDayDashboardSummary?.phone_outbound_call_count > 0 ? this.calculatePercentage(this.currentDayDashboardSummary.phone_outbound_contact_count, this.currentDayDashboardSummary.phone_outbound_call_count) : 0;
            },
            serviceLevel() {

                // Verify we have inbound calls
                if (!(this.currentDayDashboardSummary?.phone_inbound_call_count > 0)) {
                    return null;
                }

                // Formula = 100% - adjusted agent drop % - adjusted vm %
                return 100.0 - this.adjustedAgentDropPercentage - this.adjustedVoiceMailPercentage;
            },
            serviceLevelColor() {

                // Only assign color if we have inbound calls (default green)
                if (!(this.phone_inbound_call_count > 0)) {
                    return "var(--success)";
                }

                // alert green
                if (this.serviceLevel >= 90) {
                    return "var(--success)";
                }

                // alert warning
                if (this.serviceLevel >= 80) {
                    return "var(--orange)";
                }

                // alert error
                return "var(--error)";
            },
            totalCallsWaiting() {
                return (this.callsWaiting?.length || 0);
            },
            totalLongHoldCalls() {

                // Init
                let total = 0;

                // Verify
                if (this.totalCallsWaiting > 0) {

                    // Loop over and count
                    for (let i = 0; i < this.totalCallsWaiting; i++) {

                        // Init
                        const ccq = this.callsWaiting[i];
                        if (!ccq || !(ccq.call_communication_queue_id > 0)) {
                            continue;
                        }

                        // Check if long
                        if (ccq.hold_time_in_seconds < this.longCallDuration) {
                            continue;
                        }

                        total++;
                    }
                }

                return total;
            },
            validDayDashboardSummary() {
                return this.currentDayDashboardSummary?.id > 0;
            },
        },
        components: {
        },
        props: {
            callsWaiting: Array,
            currentDayDashboardSummary: Object,
            sheetHeight: Number,
            teamScopeEmptyMessage: String,
        },
        watch: {
        },
        destroyed() {
        },
        created() {
        },
        mounted() {
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .cell-value-spacing {
            padding: 0 0 5px 0;
        }

        .task-border-right {
            border-right: 2px solid var(--off-white);
        }

        .task-border-left {
            border-left: 2x solid var(--off-white);
        }
    }
</style>